import React, { Component } from 'react'
import AriaModal from 'react-aria-modal'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { RadioButton, Input, Alert, Icon } from 'loyal-react'
import ReactStars from 'react-rating-stars-component'

class GoogleForms extends Component {
  constructor (props) {
    super(props)
    this.state = {
      rating: 0,
      reason: '',
      others: '',
      comments: '',
      send: false,
      showModal: true
    }
    setTimeout(() => {
      this.setState({ showModal: this.props.closeDonation })
    }, 1000)
  }

  getApplicationNode = () => {
    setTimeout(() => {
      const reactStars = document.querySelectorAll('[class^="react-stars-wrapper"] .react-stars')
      if (reactStars && reactStars.length > 0) {
        Array.from(reactStars).forEach(reactStar => {
          reactStar.setAttribute('aria-label', 'Adicione classificação digitando um número inteiro de 0 a 5 ou pressionando as teclas de seta')
        })
      }
    }, 300)

    return document.querySelector('#root')
  }
  handleChangeRating = (e) => {
    this.setState({ rating: e })
  }
  handleChangeReason = (e) => {
    this.setState({ reason: e.target.value })
  }
  handleChangeOther = (e) => {
    this.setState({ others: e.target.value })
  }
  handleChangeComment = (e) => {
    this.setState({ comments: e.target.value })
  }
  onSubmitGoogleForms = () => {
    this.setState({ send: true })
  }
  closeNPS = () => {
    this.setState({ showModal: false })
  }
  render () {
    return this.state.showModal ? <AriaModal
      titleText='Como foi sua experiência?'
      focusDialog='true'
      getApplicationNode={this.getApplicationNode}
      underlayStyle={{ zIndex: 9999 }}
      dialogStyle={{ maxWidth: '650px' }}
      onExit={() => this.closeNPS()}

    >
      <div className='container-fluid container-nps py-0' data-campaign={process.env.REACT_APP_CATALOG_ID}>
        <div className='pos-absolute zindex-high r-1 r-md-3 t-1 t-md-3'>
          <a role='button'
            href='javascript:void(0)'
            aria-label='Fechar'
            onClick={this.closeNPS} className='txt-subtitle txt-font-body d-block'>
            <Icon
              iconName='icon_close'
              className='color-ui-1 cursor icon-md'
            />
          </a>
        </div>
        <div className='container pt-3 pt-md-0'>
          <div className='row'>
            <div className='col-11 mx-auto py-3'>
              <div className='row'>
                <div className='col-12 mb-3'>
                  <h1>Queremos sua opinião.</h1>
                </div>
              </div>
              <div className='row  mb-2'>
                <div className='product-rating nps col-12'>

                  {
                    this.state.send && <Alert
                      isSuccess
                      title={'Avaliação enviada com sucesso!'}
                      description={'Sua experiência é muito importante para nós.'}
                      className='pb-2'
                      onClose={this.closeNPS}
                    />
                  }

                  <h2 className={`txt-body mb-1 ${this.state.send && 'd-none'}`}>Avalie sua experiência de compra.</h2>
                  <div className={`row mx-0  ${this.state.send && 'd-none'}`}>
                    <div className={`col-12 store-rating modal-rating-stars mx-0 px-1 ${this.state.rating && 'rating-empty'}`}>
                      <ReactStars
                        count={5}
                        onChange={this.handleChangeRating}
                        size={36}
                        activeColor='#ffd700'
                        emptyIcon={<i className='icon icon_star' />}
                        filledIcon={<i className='icon icon_rating color-brand-1' />}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {
                this.state.rating > 0 && this.state.rating < 5 && <div className={`row mb-2  ${this.state.send && 'd-none'}`}>
                  <div className='col-12'>
                    <h2 className='txt-body mb-1'>Queremos entender um pouco mais, conta pra gente se algum desses motivos são a razão desta nota:</h2>
                    <div className='row'>
                      <div className='box-nps-atraso col-12'>
                        <div className='row'>
                          <RadioButton
                            id='atraso'
                            name='motivo'
                            value='Atraso na entrega do resgate'
                            label='Atraso na entrega do resgate'
                            className='col-12'
                            labelClass='l-1'
                            outerLabel={false}
                            role='radio'
                            onClick={(e) => this.handleChangeReason(e)}
                          />
                        </div>
                      </div>
                      <div className='box-nps-quantidade col-12'>
                        <div className='row'>
                          <RadioButton
                            id='quantidade'
                            name='motivo'
                            value='Quantidade de produtos disponíveis para resgate'
                            label='Quantidade de produtos disponíveis para resgate'
                            className='col-12'
                            labelClass='l-1'
                            outerLabel={false}
                            role='radio'
                            onClick={(e) => this.handleChangeReason(e)}
                          />
                        </div>
                      </div>
                      <div className='box-nps-lentidao col-12'>
                        <div className='row'>
                          <RadioButton
                            id='lentidao'
                            name='motivo'
                            label='Lentidão no site'
                            value='Lentidão no site'
                            className='col-12'
                            labelClass='l-1'
                            outerLabel={false}
                            role='radio'
                            onClick={(e) => this.handleChangeReason(e)}
                          />
                        </div>
                      </div>
                      <div className='box-nps-outros col-12'>
                        <div className='row'>
                          <RadioButton
                            id='outros'
                            name='motivo'
                            value='Outros'
                            label='Outros'
                            className='col-12'
                            labelClass='l-1'
                            outerLabel={false}
                            role='radio'
                            onClick={(e) => this.handleChangeReason(e)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

              {
                this.state.reason === 'Outros' && <div className={`row mb-2  ${this.state.send && 'd-none'}`}>
                  <div className='col-12'>
                    <h2 className='txt-body mb-1'>Qual o motivo?</h2>
                  </div>
                  <Input
                    id='nps-outros'
                    name='outro'
                    label='Outros'
                    className='col-12'
                    onChange={(e) => this.handleChangeOther(e)}
                  />
                </div>
              }
              <div className={`row mb-2  ${this.state.send && 'd-none'}`}>
                <div className='col-12'>
                  <h2 className='txt-body mb-1'>Deixe um comentário.</h2>
                </div>
                <Input
                  id='nps-comentario'
                  name='comentario'
                  label='Comentário'
                  className='col-12'
                  onChange={(e) => this.handleChangeComment(e)}
                />
              </div>

              <iframe name='hidden_iframe' id='hidden_iframe' className='d-none' />
              <form action='https://docs.google.com/forms/d/e/1FAIpQLSfGon9c5NOr6SeDEJyu73dFkePZM5-KxKtkyKpvcFmqshMDkg/formResponse' method='post' target='hidden_iframe'>
                <input name='entry.343519078' type='hidden' value={this.state.rating} />
                <input name='entry.452954092' type='hidden' value={this.state.reason} />
                <input name='entry.1470350034' type='hidden' value={this.state.comments} />
                <input name='entry.185601226' type='hidden' value={this.state.others} />

                <input name='entry.252273565' type='hidden' value={this.props.profile && this.props.profile['custom:campaign_id']} />
                <input name='entry.1164317006' type='hidden' value={this.props.profile && this.props.profile['custom:catalog_id']} />
                <input name='entry.419888676' type='hidden' value={this.props.profile && this.props.profile['custom:client_id']} />

                <input type='submit' value='Enviar' className={`btn btn-nps-send btn-featured mx-auto ${this.state.send && 'd-none'}`} onClick={this.onSubmitGoogleForms} />
              </form>
            </div>
          </div>
        </div>
      </div>
    </AriaModal> : ''
  }
}
GoogleForms.propTypes = {
  profile: PropTypes.shape({
    'custom:campaign_id': PropTypes.string.isRequired,
    'custom:catalog_id': PropTypes.string.isRequired,
    'custom:client_id': PropTypes.string.isRequired
  }),
  closeDonation: PropTypes.bool
}

const mapStateToProps = ({ oidc: { user } }) => ({
  profile: user && user.profile
})

export default connect(mapStateToProps)(GoogleForms)



// WEBPACK FOOTER //
// ./src/features/Nps/GoogleForms.js